const itemTypeCategories = {
  PERSON: "PERSON",
  LOCATION: "LOCATION",
  OTHER: "OTHER"
};

const itemTypeCategoryLabels = {
  PERSON: "Person",
  LOCATION: "Location",
  OTHER: "Other"
};

const getitemTypeCategoryOptions = selectedValue => {
  return Object.keys(itemTypeCategories).map(key => ({
    label: itemTypeCategoryLabels[key],
    value: key,
    selected: selectedValue === key
  }));
};

export { getitemTypeCategoryOptions };

export default itemTypeCategories;
